export default {
  "content": "<path d=\"M9.567 2.914a.469.469 0 01.865 0l1.772 4.26c.067.162.22.272.395.287l4.599.368a.469.469 0 01.267.823l-3.503 3.002a.47.47 0 00-.151.464l1.07 4.488a.469.469 0 01-.7.509l-3.937-2.405a.469.469 0 00-.489 0l-3.937 2.405a.469.469 0 01-.7-.51l1.07-4.487a.469.469 0 00-.15-.464L2.533 8.652A.469.469 0 012.8 7.83L7.4 7.461a.469.469 0 00.395-.288l1.772-4.26z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};